import P2O5DensityTable from '../assets/P2O5DensityTable'
import H2SO4DensityTable from '../assets/H2SO4DensityTable'
import PhysicalProperties from '../assets/PhysicalProperties'
import EbulitionChartTable from '../assets/EbulitionChartTable'
import H2SiF6PropertiesTable from '../assets/H2SiF6PropertiesTable'
import { closest } from './util'

// Module de calcul des tables de propriété
// Ce module doit permettre d'effectuer les conversions sur base des 5 tables de propriétés fournies

/** Calcul du pourcentage de densité de P2O5 */
export const P2O5Density = ({ density, temperature }) => {
    const temperatures = [
        { tmp: 20 },
        { tmp: 30 },
        { tmp: 40 },
        { tmp: 50 },
        { tmp: 60 },
        { tmp: 65 },
        { tmp: 70 },
        { tmp: 75 },
        { tmp: 80 },
        { tmp: 85 },
    ]
    const { tmp } = closest(temperatures, 'tmp', temperature) // on récupère la température la plus proche
    const line = closest(P2O5DensityTable, `d${tmp}`, density) // On cherche la densité la plus proche pour la température donnée
    return { temperature: tmp, density: line[`d${tmp}`], percentage: line["percentage"] } // On retourne un nouvel objet : {temperature, density, percentage}
}

/** Calcul du pourcentage de densité de H2SO4 */
export const H2SO4Density = ({ density, temperature }) => {
    const temperatures = [
        { tmp: 0 },
        { tmp: 10 },
        { tmp: 15 },
        { tmp: 20 },
        { tmp: 25 },
        { tmp: 30 },
        { tmp: 40 },
        { tmp: 50 },
        { tmp: 60 },
        { tmp: 80 },
    ]
    const { tmp } = closest(temperatures, 'tmp', temperature) // on récupère la température la plus proche
    const line = closest(H2SO4DensityTable, `${tmp}C`, density) // On cherche la densité la plus proche pour la température donnée
    return { temperature: tmp, density: line[`${tmp}C`], percentage: line["percentage"] } // On retourne un nouvel objet : {temperature, density, percentage}
}

/** Calcul des propriétés physiques */
export const physicalProperties = ({ val, type }) => {
    switch (type) {
        case 'PRESSURE':
            const resultPressure = closest(PhysicalProperties, 'absolutePressure', val)
            return { ...resultPressure, val: resultPressure.absolutePressure }
        case 'TEMPERATURE':
            const resultTemperature = closest(PhysicalProperties, 'temperature', val)
            return { ...resultTemperature, val: resultTemperature.temperature }
        default: break
    }
}

/** Calcul de la pression absolue requise */
export const ebullitionChartProperties = ({ temperature, percent }) => {
    const percentages = [
        {
            percentage: 52
        },
        {
            percentage: 53
        },
        {
            percentage: 54
        }
    ]
    const { percentage } = closest(percentages, 'percentage', percent) // on récupère le pourcentage le plus proche
    const line = closest(EbulitionChartTable, "ebullitionTemperature", temperature) // On cherche la temperature la plus proche
    return { percentage, temperature: line["ebullitionTemperature"], pressure: line[`${percentage}P2O5Abs`] } // On retourne un nouvel objet : {temperature, density, percentage}
}

/** Calcul du pourcentage de H2SiF6 */
export const H2SiF6Density = ({ density, temperature }) => {
    const temperatures = [
        { tmp: 18 },
        { tmp: 20 },
        { tmp: 30 },
        { tmp: 40 },
        { tmp: 50 },
        { tmp: 60 },
        { tmp: 70 }
    ]
    const { tmp } = closest(temperatures, 'tmp', temperature) // on récupère la température la plus proche
    const line = closest(H2SiF6PropertiesTable, `d${tmp}`, density) // On cherche la densité la plus proche pour la température donnée
    return { temperature: tmp, density: line[`d${tmp}`], percentage: line["percentage"] } // On retourne un nouvel objet : {temperature, density, percentage}
}